import { Box, Typography } from "@mui/material";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import moment from "moment";
import { DataTableColumn } from "../../../components/ui";
import { GiftModel } from "./table/gift.model";

/** Formata uma data ("DD/MM/YYYY") ou "—" quando ausente. */
function formatDate(date: Date): string {
    if (!date) return "—";
    return moment(date).utcOffset(-180).format("DD/MM/YYYY");
}

/** Colunas da tabela de brindes (E-mail / Plano / Enviado / Utilizado / Fim do plano). */
export function buildGiftColumns(): DataTableColumn<GiftModel>[] {
    return [
        {
            key: "email",
            header: "E-mail",
            width: "2.5fr",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    {row.isNewUser && <FiberNewIcon sx={{ fontSize: 16, color: "primary.main" }} />}
                    <Typography sx={{ fontSize: "13.5px", fontWeight: 500, color: "text.primary" }}>{row.email}</Typography>
                </Box>
            ),
        },
        {
            key: "plan",
            header: "Plano",
            width: "1fr",
            render: (row) => <Typography sx={{ fontSize: "13.5px", color: "text.primary" }}>{row.plan || "—"}</Typography>,
        },
        {
            key: "createdAt",
            header: "Enviado",
            width: "1fr",
            render: (row) => <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>{formatDate(row.createdAt)}</Typography>,
        },
        {
            key: "usedIn",
            header: "Utilizado",
            width: "1fr",
            render: (row) => <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>{formatDate(row.usedIn)}</Typography>,
        },
        {
            key: "endPlanDate",
            header: "Fim do plano",
            width: "1fr",
            render: (row) => <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>{formatDate(row.endPlanDate)}</Typography>,
        },
    ];
}
